var $ = jQuery

$(document).ready(function () {
    //* Isotope
    $('.single-year .cards').each(function () {
        
        $(this).isotope({
            // options
            itemSelector: '.single-box',
            layoutMode: 'fitRows',
            percentPosition: true,
            fitRows: {
                gutter: '.grid-gap'
            },
            transitionDuration: 0
        });
    })
    var id = GetURLParameter('id');
    var el = $('#' + id)
    if (el.length > 0) {
        
        // if (el.parent('.single-year').hasClass('hideAll')) {
            
        //     el.parent('.single-year').removeClass('hideAll')
        //     el.parent('.single-year').prev('.dis').removeClass('hideAll')
        //     el.parent('.single-year').prev('.dis').prev('.plus').toggle()
        //     $('.single-year').each(function () {
                
        //         $(this).isotope();
        //     })
        // }
        $('.publi-main').css({'opacity':'0'})
        setTimeout(function () {
            if ($(window).width() < 900) {
                var op = el.offset().top - 50
                console.log(op)
                $('html, body').animate({
                    scrollTop: op - $('.filter-mobile').outerHeight() - 32
                }, 0)
            } else {
                
                $('html, body').animate({
                    scrollTop: el.offset().top - 32
                }, 0)
            }
            $('.publi-main').css({'opacity':'1'})
            
        }, 1000)
    } 
    
})

function GetURLParameter(sParam)
{
    var sPageURL = window.location.search.substring(1);
    var sURLVariables = sPageURL.split('&');
    for (var i = 0; i < sURLVariables.length; i++)
    {
        var sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] == sParam)
        {
            return sParameterName[1];
        }
    }
}